import { createAuthClient } from "better-auth/react"
import { magicLinkClient, oneTapClient, customSessionClient } from "better-auth/client/plugins"
import type { auth } from "./index"

export const authClient = createAuthClient({
  baseURL: process.env.NEXT_PUBLIC_BETTER_AUTH_URL || "http://localhost:10000",
  plugins: [
    magicLinkClient(),
    customSessionClient<typeof auth>(),
    oneTapClient({
      autoSelect: false,
      context: "signin",
      cancelOnTapOutside: true,
      clientId: process.env.NEXT_PUBLIC_AUTH_GOOGLE_ID!,
      promptOptions: {
        baseDelay: 1000,
        maxAttempts: 5
      }
    })
  ]
})

export const { signIn, signOut, signUp, useSession, oneTap } = authClient
